import { observable, computed, autorun, action } from 'mobx';

import {
  THEME,
  KIND,
  TYPE,
  CLOSE_TYPE
} from '-enums';

export class AppStore {

  get apiKey() {
    return "27a9691688dcd0cf51853c0b37a9260ee74b210b34da67fe8a6deb07e28529f2bd3fa50aa0250f816a";
  }

  @observable kind = KIND.TREE;
  @observable group = null;
  @observable events = null;
  @observable type = TYPE.TNVED;
  @observable theme = THEME.LIGHT;
  @observable date = null;
  @observable code = '';
  @observable dominantMode = false;
  @observable widgetId = '';
  @observable fullWidth = false;
  @observable fullHeight = false;

  @observable dense = false;
  @observable searchTerm = '';
  @observable searchOpen = false;
  @observable expanded = null;
  @observable closeType = CLOSE_TYPE.CLOSE;
  @observable disableInfo = false;

  @observable showTitle = true;
  @observable collapsed = false;

  @observable pageTitle = 'qBorder';
  @observable currentUser = null

  @observable createKeyService = null

  @computed
  get isTree() {
    return this.kind === KIND.TREE;
  }

  constructor() {
    autorun(() => {

      if (this.kind === KIND.TREE) {
        this.code = '';
      }

      if (this.kind === KIND.INFO) {
        this.type = TYPE.TNVED;
      }

    });
  }

  @action.bound
  showCreateKeyModal(service) {
    this.createKeyService = service
  }

}

export default new AppStore();



// WEBPACK FOOTER //
// ./src/stores/AppStore.js